import React, {useState} from "react";
import AnimatedButton from "../../ui/motion/AnimatedButton";
import {useSubmitFormAction} from "../../../hooks/useSubmitFormAction";
import {useSubmit} from "react-router-dom";
import Heading from "../../common/header/Heading";
import AdminKedNavbar from "./AdminKedNavbar";
import {VerifyCodeOrEmailResponse} from "../../../model/admin/UserCourse";


export default function AdminKedVerification() {
    const {isSubmitting} = useSubmitFormAction('whatever', null, (body) => {
        setResponse(body as unknown as VerifyCodeOrEmailResponse);
    }, false, undefined, undefined, true);

    const [codeOrEmail, setCodeOrEmail] = useState<string>('');

    const [response, setResponse] = useState<VerifyCodeOrEmailResponse | null>(null)

    const submit = useSubmit();

    function verifyCodeOrEmail() {
        submit({
            codeOrEmail: codeOrEmail.trim(),
        }, {
            method: "POST",
        });
    }

    function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === 'Enter' && codeOrEmail.trim() !== '') {
            event.preventDefault();
            verifyCodeOrEmail();
        }
    }

    function formatDate(dateString?: string) {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('pl-PL', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    function formatWatchTime(watchTime?: number) {
        if (watchTime === undefined || watchTime === null) return 'N/A';
        const hours = Math.floor(watchTime / 3600);
        const minutes = Math.floor((watchTime % 3600) / 60);
        const seconds = Math.floor(watchTime % 60);

        return `${hours > 0 ? `${hours}h ` : ''}${minutes > 0 ? `${minutes}m ` : ''}${seconds}s`;
    }

    const renderDetails = () => {
        if (!response || !response.details || response.details.length === 0) return null;

        const detailsCount = response.details.length;
        const colClass = detailsCount === 1 ? 'col-md-6' : 'col-md-5';

        return (
            <div className="row justify-content-center mt-4">
                {/*sort by boughtAt*/}
                {response.details.sort((a, b) => (a.boughtAt && b.boughtAt ? new Date(b.boughtAt).getTime() - new Date(a.boughtAt).getTime() : 0)).map((detail, index) => (
                    <div key={index} className={`${colClass} mb-4 ${detailsCount > 1 ? 'mx-2' : ''}`}>
                        <div className="card bg-dark text-white border border-success">
                            <div className="card-header bg-success bg-opacity-25 fw-bold text-white">
                                Szczegóły kodu {index + 1}
                            </div>
                            <div className="card-body">
                                <ul className="list-group list-group-flush bg-transparent">
                                    <li className="list-group-item bg-dark text-white border-secondary">
                                        <span className="fw-bold text-light">Typ Kursu:</span> <span
                                        className="text-light">{detail.courseType}</span>
                                    </li>
                                    <li className="list-group-item bg-dark text-white border-secondary">
                                        <span className="fw-bold text-light">Wykorzystany:</span> <span
                                        className="text-light">{detail.used ? 'Tak' : 'Nie'}</span>
                                    </li>
                                    <li className="list-group-item bg-dark text-white border-secondary">
                                        <span className="fw-bold text-light">Konto aktywowane:</span> <span
                                        className="text-light">{detail.activatedAccount ? 'Tak' : 'Nie'}</span>
                                    </li>
                                    {detail.activationRequestFor && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span className="fw-bold text-light">Żądanie aktywacji dla:</span> <span
                                            className="text-light">{detail.activationRequestFor}</span>
                                        </li>
                                    )}
                                    {detail.childActivationLink && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span
                                                className="fw-bold text-light">Link do aktywacji konta dla dziecka:</span><br/>
                                            <span className="text-light">{detail.childActivationLink}</span>
                                        </li>
                                    )}
                                    {detail.activationLink && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span className="fw-bold text-light">Link do aktywacji konta:</span> <span
                                            className="text-light">{detail.activationLink}</span>
                                        </li>
                                    )}
                                    {detail.activatedAccountFor && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span className="fw-bold text-light">Konto aktywowane dla:</span> <span
                                            className="text-light">{detail.activatedAccountFor}</span>
                                        </li>
                                    )}
                                    {detail.boughtAt && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span className="fw-bold text-light">Zakupiony:</span> <span
                                            className="text-light">{formatDate(detail.boughtAt)}</span>
                                        </li>
                                    )}
                                    {detail.boughtBy && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span className="fw-bold text-light">Zakupiony przez:</span> <span
                                            className="text-light">{detail.boughtBy}</span>
                                        </li>
                                    )}
                                    {detail.watchTime !== undefined && (
                                        <li className="list-group-item bg-dark text-white border-secondary">
                                            <span className="fw-bold text-light">Czas oglądania:</span> <span
                                            className="text-light">{formatWatchTime(detail.watchTime)}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderResponse = () => {
        if (!response) return null;

        return (
            <div className="mt-5">
                {response.error && (
                    <div className="alert bg-danger bg-opacity-25 text-white border border-danger mw-md-4xl mx-auto"
                         role="alert">
                        <strong>Błąd:</strong> {response.errorMessage || 'Wystąpił nieznany błąd podczas weryfikacji.'}
                    </div>
                )}

                {!response.error && !response.exists && (
                    <div className="alert bg-warning bg-opacity-25 text-white border border-warning mw-md-4xl mx-auto"
                         role="alert">
                        <strong>Informacja:</strong> Podany kod lub email nie istnieje w systemie.
                    </div>
                )}

                {!response.error && response.exists && (
                    <div className="alert bg-success bg-opacity-25 text-white border border-success mw-md-4xl mx-auto"
                         role="alert">
                        <strong>Sukces:</strong> Znaleziono informacje dla podanego kodu lub emaila.
                    </div>
                )}

                {renderDetails()}
            </div>
        );
    };

    return <>
        <Heading title='Weryfikacja kodu lub emaila' badgeText='weryfikacja'/>
        <AdminKedNavbar/>
        <hr className='text-white'/>
        <div className='container'>
            <div className='row justify-content-center mt-4 mb-4'>
                <div className='col-12 col-md-6'>
                    <div className='form-group mb-4'>
                        <label
                            className='mb-2 text-white fw-bold'
                            htmlFor='modalInput2-1'
                        >
                            Kod lub email
                        </label>
                        <input
                            className='input-lg form-control shadow-sm border-0 bg-dark'
                            id='modalInput2-1'
                            type='text'
                            placeholder="3058928a-8f00-44e8-82ed-e6ee3ed853d1"
                            aria-describedby='title'
                            value={codeOrEmail}
                            onChange={(event) => setCodeOrEmail(event.target.value)}
                            onKeyDown={handleKeyDown}
                            style={codeOrEmail ? {color: 'white'} : {}}
                        />
                    </div>
                    <div className='d-flex justify-content-center mt-4'>
                        <AnimatedButton
                            className='btn btn-lg btn-success py-3 px-5 shadow'
                            onClick={() => verifyCodeOrEmail()}
                            disabled={isSubmitting}
                            customScale={1}
                        >
                            Sprawdź
                        </AnimatedButton>
                    </div>
                </div>
            </div>

            {renderResponse()}
        </div>
    </>
}